import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {PageHeading} from '@/components/ui/page-atoms/PageAtoms'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'

export const ProjectFormHeadingLoader = () => {
    return (
        <PageHeading align="center" justify="space-between">
            <h2>
                <Skeleton height={32} width={200} />
            </h2>
            <Flexbox gap={2}>
                <Skeleton height={32} width={100} />
                <Skeleton height={32} width={100} />
            </Flexbox>
        </PageHeading>
    )
}
